import { getLocale } from '@/assets/js/utils/browser';
import { DEFAULT_LOCALE } from '@/utils/Constants';
import { getStore as userModule, STORE_NAME as userModuleStoreName } from '@/views/Profile/store';
import Vue from 'vue';
import Vuex from 'vuex';
import ExtraPaymentStore from '@/views/ExtraPayment/store';

// modules
import translations from './modules';
import returnTransfers from './modules/returnTransfers';

import getters from './getters';
import mutations from './mutations';
import actions from './actions';


Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    translations,
  },
  state: {
    lang: getLocale(DEFAULT_LOCALE),
    viewSize: 'lg',
    globalError: false,
    operationError: '',
  },
  getters,
  mutations,
  actions,
});

store.registerModule(userModuleStoreName, userModule());
store.registerModule('$_returnTransfers', returnTransfers);
ExtraPaymentStore.register(store);

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js